import {
  Component,
  EventEmitter,
  Input,
  Output,
  forwardRef,
  TemplateRef,
} from '@angular/core';

import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'cigna-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxComponent),
      multi: true,
    },
  ],
})
export class CheckboxComponent implements ControlValueAccessor {
  @Input() label?: string;
  @Input() labelTemplate?: TemplateRef<any>;
  @Input() id = '';
  @Input() name = '';
  // eslint-disable-next-line @typescript-eslint/naming-convention
  @Input() checked: boolean;
  @Input() ariaDescribedby?: string;
  @Input() ariaRequired?: string;
  @Input() ariaLabelledby?: string;
  @Output() click: EventEmitter<any> = new EventEmitter<any>();
  @Output() change: EventEmitter<any> = new EventEmitter<any>();
  @Output() focus = new EventEmitter<any>();
  @Output() blur = new EventEmitter<any>();
  @Input() isDisabled = false;
  @Input() isInvalid = false;

  onChange = (checked: boolean) => {};

  onClick(event: any) {
    event.stopPropagation();
    this.click.emit(event);
  }

  changed(event: any) {
    event.stopPropagation();
    this.checked = !this.checked;
    this.writeValue(this.checked);
    this.change.emit(this.checked);
  }

  writeValue(value: any) {
    this.checked = value ?? false;
    this.onChange(this.checked);
  }

  registerOnChange(fn: any) {
    // Allow angular to register onChange event
    this.onChange = fn;
  }

  registerOnTouched() {}
}
